import Swiper from "swiper";
import { Navigation, Autoplay, EffectFade } from "swiper/modules";

const interval = setInterval(() => {
  const viewer = document.querySelector("spline-viewer");
  if (viewer && viewer.shadowRoot) {
    const logo = viewer.shadowRoot.querySelector("#logo");
    if (logo) {
      logo.remove(); // Removes the logo element entirely
      clearInterval(interval);
    }
  }
}, 500);

/*SLIDESHOW*/
const slideShow = new Swiper(".slideshow", {
  modules: [Navigation, Autoplay, EffectFade],
  slidesPerView: 1,
  spaceBetween: 20,
  loop: true,
  autoplay: {
    delay: 5000,
  },
  effect: "fade",
  fadeEffect: {
    crossFade: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});
/*END SLIDESHOW*/

/*SLIDE SERVIZI*/
const slideServizi = new Swiper(".slide-servizi", {
  modules: [Navigation],
  slidesPerView: 1,
  spaceBetween: 20,
  loop: true,
  breakpoints: {
    768: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    1500: {
      slidesPerView: 5,
      spaceBetween: 20,
    },
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});
/*END SLIDE SERVIZI*/

/*MENU*/
document.addEventListener("DOMContentLoaded", function () {
  const nav = document.querySelector(".wp-block-navigation");
  const burgerBtn = nav?.querySelector(
    ".wp-block-navigation__responsive-container-open",
  );
  const container = nav?.querySelector(
    ".wp-block-navigation__responsive-container",
  );
  const submenuItems = nav?.querySelectorAll("li.wp-block-navigation-submenu");
  const header = document.querySelector("header");
  const BREAKPOINT = 1024;

  const isMobile = () => window.innerWidth < BREAKPOINT;

  const closeMenu = () => {
    container?.classList.remove("is-menu-open");
    header?.classList.remove("is-menu-open");
  };

  // Toggle apertura menu mobile
  if (burgerBtn && container) {
    burgerBtn.addEventListener("click", () => {
      container.classList.toggle("is-menu-open");
      header.classList.toggle("is-menu-open");
    });
  }

  // Toggle sottomenù su mobile
  submenuItems?.forEach((item) => {
    item.addEventListener("click", (e) => {
      if (!isMobile()) return;

      const link = item.querySelector("a.wp-block-navigation-item__content");
      if (link && link.contains(e.target)) {
        e.preventDefault();
      }

      e.stopPropagation();

      document
        .querySelectorAll("li.wp-block-navigation-submenu.is-submenu-open")
        .forEach((el) => {
          if (el !== item) el.classList.remove("is-submenu-open");
        });

      item.classList.toggle("is-submenu-open");
    });
  });

  // Chiudi menu al click su un link (ancore)
  container
    ?.querySelectorAll("a.wp-block-navigation-item__content")
    .forEach((link) => {
      link.addEventListener("click", () => {
        if (isMobile()) closeMenu();
      });
    });

  // Sposta il menu fuori dall'header su mobile
  const relocateResponsiveContainer = () => {
    if (!container || !header) return;

    if (isMobile()) {
      if (container.parentNode !== document.body) {
        document.body.appendChild(container);
      }
    } else {
      if (container.parentNode !== nav) {
        nav.appendChild(container);
      }
    }
  };

  relocateResponsiveContainer();
  window.addEventListener("resize", () => {
    relocateResponsiveContainer();

    if (!isMobile() && container?.classList.contains("is-menu-open")) {
      closeMenu();
    }
  });
});
/*END MENU*/

/*ICON TOP*/
(function () {
  const btn = document.querySelector(".icon-top");
  if (!btn) return;

  const threshold = window.innerHeight * 2; // 200vh

  function toggleBtn() {
    if (window.scrollY > threshold) {
      btn.classList.add("is-visible");
    } else {
      btn.classList.remove("is-visible");
    }
  }

  window.addEventListener("scroll", toggleBtn, { passive: true });
  toggleBtn(); // controlla subito al caricamento
})();
/* END ICON TOP */
